import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  class: "grid-x",
  id: "mobile-topbar"
}
const _hoisted_2 = { class: "cell shrink left-section" }
const _hoisted_3 = { class: "grid-x align-center align-middle" }
const _hoisted_4 = { class: "cell shrink right-section" }
const _hoisted_5 = { class: "menu icons" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_burger_menu = _resolveComponent("burger-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mobile_topbar_user_component = _resolveComponent("mobile-topbar-user-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_burger_menu, {
          "is-open": _ctx.mobileMenuOpen,
          onToggle: _ctx.toggleMobileMenu
        }, null, 8, ["is-open", "onToggle"]),
        _createVNode(_component_router_link, {
          to: "/",
          id: "mobile-topbar-logo",
          class: "grid-x align-center align-middle"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "horstCOSMOS Logo",
              loading: "lazy"
            }, null, -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cell auto center-section" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_mobile_topbar_user_component, { id: "topbar-user-mobile" })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-nav", { 'mobile-nav-open': _ctx.mobileMenuOpen }])
    }, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredElements, (element, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "mobile-nav-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMobileItemClick && _ctx.handleMobileItemClick(...args)))
          }, [
            (element.externalLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: element.externalLink,
                  target: "_blank"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([element.icon, "bi"]),
                    "aria-hidden": "true"
                  }, null, 2),
                  (element.titleLocale)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t(element.titleLocale)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(element.title), 1))
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            (element.link)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: element.link,
                  class: _normalizeClass({ selected: _ctx.activeElement.title.startsWith(element.title) })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass([element.icon, "bi"]),
                      "aria-hidden": "true"
                    }, null, 2),
                    (element.titleLocale)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(element.titleLocale)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(element.title), 1))
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}